import { Pipe, PipeTransform } from '@angular/core';
import { formatFlexibleDate } from '../utils/safe-date.util';

@Pipe({
    standalone: false,
  name: 'safeDate'
})
export class SafeDatePipe implements PipeTransform {
  transform(value: any, format?: string): string {
    const separator = format && format.indexOf('-') >= 0 ? '-' : '/';
    return formatFlexibleDate(value, separator);
  }
}
